/**
 * --- KONSEP: PUSAT NOTIFIKASI (MODAL/POPUP) ---
 * File ini mengatur munculnya pesan popup (berhasil, gagal, atau konfirmasi)
 * di seluruh aplikasi. Jadi, halaman mana pun bisa memunculkan pesan tanpa
 * harus membuat kotak pesan sendiri-sendiri.
 */
import React, { createContext, useContext, useState } from "react";

const NotificationContext = createContext();

export const NotificationProvider = ({ children }) => {
  // --- MEMORI (STATE): Menyimpan status kotak pesan ---
  const [notification, setNotification] = useState({
    isOpen: false, // Apakah kotak sedang tampil?
    type: "success", // Jenis: "success" (hijau), "error" (merah), atau "warning"
    title: "", // Judul pesan
    message: "", // Isi pesan
    onConfirm: null, // Fungsi yang dijalankan jika tombol "OKE" ditekan
    onCancel: null, // Fungsi yang dijalankan jika tombol "BATAL" ditekan
  });

  /**
   * --- LOGIKA: Menampilkan Pesan ---
   * Fungsi ini dipanggil oleh halaman lain (misal: "Barang Berhasil Ditambah")
   */
  const showNotification = React.useCallback((config) => {
    setNotification({
      isOpen: true,
      type: config.type || "success",
      title: config.title || (config.type === "error" ? "Gagal" : "Berhasil"),
      message: config.message || "",
      onConfirm: config.onConfirm || null,
      onCancel: config.onCancel || null,
    });
  }, []);

  /**
   * --- LOGIKA: Menutup Pesan ---
   */
  const closeNotification = React.useCallback(() => {
    setNotification((prev) => ({ ...prev, isOpen: false }));
  }, []);

  return (
    <NotificationContext.Provider
      value={{ notification, showNotification, closeNotification }}
    >
      {children}
    </NotificationContext.Provider>
  );
};

/**
 * --- CARA PAKAI ---
 * Halaman lain cukup menggunakan: const { showNotification } = useNotification();
 */
export const useNotification = () => {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error(
      "useNotification harus digunakan di dalam NotificationProvider",
    );
  }
  return context;
};
